"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDisplaySizeItem = void 0;
class FileDisplaySizeItem {
    constructor({ width, height }) {
        this.toJSON = () => ({
            width: this.width,
            height: this.height,
        });
        this.width = width;
        this.height = height;
    }
}
exports.FileDisplaySizeItem = FileDisplaySizeItem;
FileDisplaySizeItem.fromJSON = (json) => {
    const { width, height } = Object.assign({}, json);
    if (typeof width !== 'number' || Number.isNaN(width))
        throw new Error('.width must be a number');
    if (typeof height !== 'number' || Number.isNaN(height))
        throw new Error('.height must be a number');
    return new FileDisplaySizeItem({ width, height });
};
class FileAspectRatio {
    constructor({ size }) {
        this.toJSON = () => ({
            size: this.size.toJSON(),
        });
        this.size = size;
    }
}
FileAspectRatio.fromJSON = (json) => {
    const { size } = Object.assign({}, json);
    const _size = FileDisplaySizeItem.fromJSON({
        width: size.width,
        height: size.height,
    });
    return new FileAspectRatio({ size: _size });
};
exports.default = FileAspectRatio;
